export default __webpack_public_path__ + "static/media/zoomout.f5d2c3a1.svg";